<div class="table-arquivo-semente">
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div style="padding-top: 4px"></div>
  }
  <mat-card appearance="outlined">
    <div class="table-container">
      <table
        #table
        mat-table
        [dataSource]="dataSource()"
        matSort
        matSortStart="desc"
        (matSortChange)="onSortChange($event)"
        class="mat-elevation-z8 responsive-table"
      >
        <!-- Coluna ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>

        <!-- Coluna Arquivo Semente -->
        <ng-container matColumnDef="gcsFieldsShapeUriOutput">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Arquivo Semente
          </th>
          <td mat-cell *matCellDef="let element">
            <span
              [title]="element.gcsFieldsShapeUriOutput"
              class="file-name-shortlink"
            >
              {{ getFileName(element.gcsFieldsShapeUriOutput) }}
            </span>
          </td>
        </ng-container>

        <!-- Coluna Responsável -->
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável</th>
          <td mat-cell *matCellDef="let element">
            {{ element.userName }}
          </td>
        </ng-container>

        <!-- Coluna Data Hora -->
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Hora</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdDate | date: "dd/MM/yyyy HH:mm:ss" }}
          </td>
        </ng-container>

        <!-- Coluna Status semente -->
        <ng-container matColumnDef="statusSeed">
          <th mat-header-cell *matHeaderCellDef>Status semente</th>
          <td mat-cell *matCellDef="let element">
            <mat-chip
              [ngClass]="getStatusClass(getStatusLabel(element))"
              disableRipple
            >
              {{ getStatusLabel(element) }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- Coluna Último Download -->
        <ng-container matColumnDef="lastDownloadOutput">
          <th mat-header-cell *matHeaderCellDef>Último Download</th>
          <td mat-cell *matCellDef="let element">
            @if (element.lastDownloadOutput) {
              {{ element.lastDownloadOutput | date: "dd/MM/yyyy HH:mm:ss" }}
            } @else {
              -
            }
          </td>
        </ng-container>

        <!-- Coluna Status -->
        <ng-container matColumnDef="statusFileSrc">
          <th mat-header-cell *matHeaderCellDef>Status Arquivo SRC</th>
          <td mat-cell *matCellDef="let element">
            <mat-chip
              [ngClass]="getStatusClass(getStatusLabelSRC(element))"
              disableRipple
            >
              {{ getStatusLabelSRC(element) }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- Coluna Último Upload -->
        <ng-container matColumnDef="lastUploadInput">
          <th mat-header-cell *matHeaderCellDef>Último Upload</th>
          <td mat-cell *matCellDef="let element">
            @if (element.lastUploadInput) {
              {{ element.lastUploadInput | date: "dd/MM/yyyy HH:mm:ss" }}
            } @else {
              -
            }
          </td>
        </ng-container>

        <!-- Coluna Inconsistência -->
        <ng-container matColumnDef="consistency">
          <th mat-header-cell *matHeaderCellDef>Inconsistência</th>
          <td mat-cell *matCellDef="let element">
            @if (element.gcsInconsistencyCsvUri && actions().length > 0) {
              <span
                (click)="
                  executeAction(actions()[0], element, $event, 'inconsistency')
                "
                class="file-name-shortlink"
                style="
                  cursor: pointer;
                  color: #1976d2;
                  text-decoration: underline;
                "
                [title]="
                  'Clique para baixar: ' +
                  getFileName(element.gcsInconsistencyCsvUri)
                "
              >
                {{ getFileName(element.gcsInconsistencyCsvUri) }}
              </span>
            } @else {
              <span>-</span>
            }
          </td>
        </ng-container>

        <!-- Coluna Erro -->
        <ng-container matColumnDef="error">
          <th mat-header-cell *matHeaderCellDef>Erro</th>
          <td mat-cell *matCellDef="let element">
            @if (element.error) {
              <span class="error-text" [title]="element.error">
                {{
                  element.error.length > 50
                    ? (element.error | slice: 0 : 50) + "..."
                    : element.error
                }}
              </span>
            } @else {
              -
            }
          </td>
        </ng-container>

        <!-- Coluna Data do Erro -->
        <ng-container matColumnDef="errorDate">
          <th mat-header-cell *matHeaderCellDef>Data do Erro</th>
          <td mat-cell *matCellDef="let element">
            @if (element.errorDate) {
              {{ element.errorDate | date: "dd/MM/yyyy HH:mm:ss" }}
            } @else {
              -
            }
          </td>
        </ng-container>

        <!-- Coluna Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td mat-cell *matCellDef="let element">
            @for (action of actions(); track action.icon) {
              @if (shouldShowAction(action, element)) {
                <button
                  mat-icon-button
                  [title]="action.label || ''"
                  (click)="executeAction(action, element, $event, 'fields')"
                  [disabled]="element.isProcessing"
                >
                  <mat-icon>{{ action.icon }}</mat-icon>
                </button>
              }
            }
          </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- Data Rows -->
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="element-row"
        ></tr>

        <!-- No data row -->
        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell"
            [attr.colspan]="displayedColumns.length"
            style="text-align: center"
          >
            Nenhum dado disponível
          </td>
        </tr>
      </table>
    </div>
  </mat-card>

  <!-- Paginator -->
  <div class="paginator-row">
    <button
      mat-icon-button
      type="button"
      (click)="onRefreshClick()"
      matTooltip="Atualizar"
      [disabled]="isLoading()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <mat-paginator
      #paginator
      [length]="length()"
      [pageSize]="5"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Selecione a página dos arquivos semente"
      class="paginator"
    >
    </mat-paginator>
  </div>
</div>
